// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__12wRU","paramInput":"JobSimulator_paramInput__xESfb","input":"JobSimulator_input__3DoJK"};